import React , { useEffect , useState } from "react";
import "./Ausbildungs.css";
// Components
import { BodyHeader } from "../../cvComponents/BodyHeader/BodyHeader";
// Images
import way from "../../../../assets/imags/Way.svg";
import { ChangedData } from "../../../../assets/ChangedData/ChangedData";
import { allData } from "../../../../Screens/lebenslauf/Lebenslauf";

// myDiv
import { AusbildungsBody } from "../../../../Screens/lebenslauf/Lebenslauf";

export const Ausbildungs = (props) =>{

    const data = props.data;
    const title = props.title;
    const allDataindex = props.index;
    
    /*_*/   const [ RendUi , seRendUi ] = useState("");

    useEffect(()=>{
        RendrUi();
    },[]);

    const RendrUi = () => {
        const rend = data.map( (section , i) => 
            <div className="ItemofTime">
            <div className="circelItem">
                <div className="circelItemIN"></div>
            </div>

            <span className="jahrdsAusbs" onClick={aa}  id={`date_${i}`} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut}  >{ section.Date }</span>

            <div className="bodyOfJTimAusb">
                <p className="hggLabel " id={`valas_${i}`} onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} >{ section.value }</p>
                <p className="hggLabel hggLabeldeck" id={`kseye_${i}`} onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} >{ section.key }</p>
            </div>
        </div>
        );
        seRendUi(rend);

        setTimeout(() => {
            const ItemofTime = document.querySelectorAll(".Ausbildungs .ItemofTime");
            ItemofTime[0].classList.add("ItemofTimeActive");
    
            const bodyOfJTimAusb = document.querySelectorAll(".Ausbildungs .bodyOfJTimAusb");
            bodyOfJTimAusb[0].classList.add("bodyOfJTimAusbActive");
        }, 20);
    }







    const aa = (event) => {
        const ItemofTime = document.querySelectorAll(".AusbildungsBody .ItemofTime");


        
        let cvBodyLayer = document.querySelector(".cvBodyLayer");
        /*
        let cvBodyLayerH = cvBodyLayer.getBoundingClientRect().height;
        const AusbildungsBodya = document.querySelector(".AusbildungsBody");
        AusbildungsBodya.style.height = "max-content";
        const inBodyHeigt = AusbildungsBodya.getBoundingClientRect().height + 150;
        const DtoH = cvBodyLayerH - inBodyHeigt;
        const toHeigt = inBodyHeigt + DtoH;
        */


        
        let nextItem = event.target.nextSibling;
        let bodyOfJTimAusb = document.getElementsByClassName("bodyOfJTimAusb");
        var myIndex = 0;
        for (let index = 0; index < bodyOfJTimAusb.length; index++) {
            if (bodyOfJTimAusb[index] == nextItem) {
                myIndex = index;
            }
        }



        bodyOfJTimAusb[myIndex].classList.toggle("bodyOfJTimAusbActive");
        cvBodyLayer.style.height = "max-content";

        ItemofTime[myIndex].classList.toggle("ItemofTimeActive");


        /*
        setTimeout(() => {
            let bodyScr4een = document.querySelectorAll(".bodyScr4een");
            console.log(bodyScr4een.length);
                // Body Height
                let H = bodyScr4een[allDataindex].children[0].getBoundingClientRect().height;
                cvBodyLayer.style.height = H + "px";
        }, 1);
        */


        if (localStorage.getItem("isLogged") == "true") {
            toTextEditFunction(event);
        }


        

    }












    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }
    const toTextEditFunction = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 1) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = "CVsections";
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;
                    let index = atributname.match(/\d+/g);
                    let way = allData.sec[allDataindex].dat[index];

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        switch (atributname[0]) {
                            case "d":
                                way.Date = textafter;
                                break;
                            case "v":
                                way.value = textafter;
                                break;
                            case "k":
                                way.key = textafter;
                                break;
                            default:
                                break;
                        }

                        // allData.sec[index[0]].head.title = textafter;
                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }else{
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
        
    }




























    return(
        <div>
            <BodyHeader title={title}idd={allDataindex}/>

            <div className="AusbildungsBody Ausbildungs">

                <div className="wayImageContainer">
                    <img src={way} className="wayImage"/>
                </div>


                { RendUi }

                

                {/*
                <div className="ItemofTime ItemofTimeActive">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>
  
                    <span className="jahrdsAusbs" onClick={aa} >2/2020 – 9/2020</span>

                    <div className="bodyOfJTimAusb bodyOfJTimAusbActive">
                        <p className="hggLabel ">Integrationskurs: Deutsche Wirtschaftsakademie in Bonn</p>
                        <p className="hggLabel hggLabeldeck">Zertifikat: B1</p>
                    </div>
                </div>


                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN">
                        </div>
                    </div>


                        <span className="jahrdsAusbs" onClick={aa}>8/2017 - 2/2018</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Abendrealschule in Bonn</p>
                    </div>
                </div>


                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                        <span className="jahrdsAusbs" onClick={aa}>01/2016 -06/2016</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Internationale Klasse des Friedrich-List-Berufskolleg in Bonn</p>
                        <p className="hggLabel hggLabeldeck">Sprachniveau A1</p>
                    </div>
                </div>


                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                    <span className="jahrdsAusbs" onClick={aa}>8/2012 – 6/2015</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Gymnasium: Tikaniat Alhasob in Aleppo/Syrien</p>
                        <p className="hggLabel hggLabeldeck">
                            Abschluss: Fachhochschulreife <br />
                            Fachbereich Computertechnik</p>
                    </div>
                </div>


                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                    <span className="jahrdsAusbs" onClick={aa}>8/2007 – 6/2012</span>
                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Mittelschule: Alsayadi in Ariha/Syrien</p>
                        <p className="hggLabel hggLabeldeck">Abschluss: Mittlere Reife</p>
                    </div>
                </div>


                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                    <span className="jahrdsAusbs" onClick={aa}>8/2003 – 6/2007</span>
                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Grundschule: BanatAriha in Ariha/Syrien</p>
                    </div>
                </div>

                */}
                

            </div>
        </div>
    );
}